export const EMPTY_HARDWARE_ORDER = {
  items: {},
  desiredDeliveryDate: "",
  onSiteHelp: false,
  onSiteHelpNotes: "",
  deliverTo: "",
  deliveryAddress: "",
  otherRequests: "",
};

export const EMPTY_EXISTING_COMPUTER = {
  existingDevicePublicId: "",
  existingDeviceSerialNumber: "",
  location: "",
};

const withoutBlanks = (object) =>
  Object.fromEntries(Object.entries(object).filter(([, value]) => value !== "" && value !== null && value !== undefined));

/**
 * The hardware part of the SCO form contract (PBI #302): "none" sends only the choice, "new"
 * sends a hardwareOrder object with product public ids and quantities, "existing" sends the
 * device reference and location. Names and prices are never sent; the API resolves them.
 */
export function buildHardwareFormData(choice, order, existingComputer) {
  if (choice === "new") {
    return {
      hardwareChoice: "new",
      hardwareOrder: {
        items: Object.entries(order.items || {})
          .filter(([, quantity]) => quantity > 0)
          .map(([hardwareProductPublicId, quantity]) => ({ hardwareProductPublicId, quantity })),
        ...withoutBlanks({
          desiredDeliveryDate: order.desiredDeliveryDate,
          onSiteHelp: !!order.onSiteHelp,
          onSiteHelpNotes: order.onSiteHelp ? order.onSiteHelpNotes : "",
          deliverTo: order.deliverTo,
          deliveryAddress: order.deliveryAddress,
          otherRequests: order.otherRequests,
        }),
      },
    };
  }

  if (choice === "existing") {
    return {
      hardwareChoice: "existing",
      ...withoutBlanks(existingComputer),
    };
  }

  return { hardwareChoice: "none" };
}

/**
 * Validation message for the hardware part, or null when it is fine to submit.
 */
export function validateHardware(choice, order) {
  if (choice === "new" && !Object.values(order.items || {}).some((quantity) => quantity > 0)) {
    return "Choose at least one product, or select \"No hardware\".";
  }
  return null;
}
